import React from "react";
import { Sun, Moon, Globe } from "lucide-react";

const TopBar = ({ lang, setLang, isDark, setIsDark, styles }) => (
  <div style={styles.topBar.container}>
    <button
      style={{ ...styles.btn, ...styles.btnSecondary, padding: "8px" }}
      onClick={() => setIsDark(!isDark)}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
    <div style={{ position: "relative" }}>
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        style={styles.topBar.select}
      >
        <option value="ru">RU</option>
        <option value="ro">RO</option>
        <option value="en">EN</option>
      </select>
      <Globe size={14} style={styles.topBar.globe} />
    </div>
  </div>
);

export default TopBar;